import React, { useState } from "react";
import "./EngagementOverTime.scss";
// import EngagementByReach from "../EngagementByReach/EngagementByReach";
// import EngagementByImpression from "../EngagementByImpression/EngagementByImpression";
// import EngagementByVideo from "../EngagementByVideo/EngagementByVideo";
// import EngagementByBookMarks from "../EngagementByBookMarks/EngagementByBookMarks";
import EngagementByLikeComment from "../EngagementByLikeComment/EngagementByLikeComment";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import { Icon, Radio } from "semantic-ui-react";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "../../../../../FbInsights/FBIntervalSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import moment from "moment-timezone";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import InstagramPageSelector from "../InstagramPageSelector";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";

function EngagementOverTime(props) {
    const [isNoData, setIsNoDataState] = useState(false);
    const [showAverage, setShowAverage] = useState(props.chartName !== "engagement_rate_over_time");
    const chart = React.useRef(null);
    const widgetName = props.chartName === "engagement_rate_over_time" ? "Page Engagement Rate over Time" : "Post Engagement";
    const downLoadCSV = () => {
        let chartName = props.widget?.name || "Post Engagement";
        let chartData = props.data || [];
        let downLoadingData = [];
        let formatString = "YYYY-MM-DD HH:mm";
        // downLoadingData.push(["Date", "Count"]);
        let currentChartData = [];
        if (props.activeTab === 0) {
            return downloadEngagementByLikesCSV();
        }
    };

    const downloadEngagementByLikesCSV = () => {
        // let data = props.data["engagement_over_time"];
        let data = props.data[props.chartName];

        const tabHeader = props.chartName === "engagement_rate_over_time" ? "Engagement Rate" : "Engagement";
        const header = ["Date", tabHeader];
        let downLoadingData = [header];

        let formatString = "YYYY-MM-DD HH:mm";
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        for (let i = 0; i < data.total_agg.length; i++) {
            downLoadingData.push([moment(data.total_agg[i][0]).tz(tz).format(formatString), data.total_agg[i][1]]);
            total += data.total_agg[i][1];
        }
        downLoadingData.push(["Total", total]);
        downLoadingData.push(["Average", data.avg_value]);

        downloadCSVData(downLoadingData, `${widgetName || "Post Engagement"}`);
    };

    const downLoadPNG = (cb) => {
        let chartName = `${widgetName || "Post Engagement"}`;

        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, chartName);
                },
            );
    };

    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };

    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={widgetName || "Post Engagement"}
                    isIGPage={props.isIGPage}
                    info={
                        props.chartName === "engagement_rate_over_time"
                            ? "This chart illustrates the cumulative change in Engagement Rate throughout the specified duration. The Engagement Rate is determined by aggregating (likes + comments + shares + views) and dividing this sum by the number of followers over the designated time frame."
                            : "This graph shows the number of times people have engaged with your posts through likes, comments. The average line shows the average engagement per post for posts that were published in the date range selected."
                    }
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!isNoData && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("bar")} className={props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>
                            <span onClick={() => props.changeGraphType("line")} className={props.graph_type === "line" ? "active-chart" : ""}>
                                <Icon name="line chart" />
                            </span>
                        </div>
                    )}
                    {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}

                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expandWidget ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {props.isPublic && isNoData ? null : (
                        <MoreOptions
                            className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                            onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!isNoData && (
                            <>
                                {/* <CustomCheckBox
                                    label="Show Unique"
                                    checked={props.showUniqueLines}
                                    onClick={() => props.changeShowUniqueLine(!props.showUniqueLines)}
                                /> */}
                                <CustomCheckBox label="Show Legends" checked={props.showLegend} onClick={() => props.changeShowLegend(!props.showLegend)} />
                                <CustomCheckBox
                                    label="Show Grid Lines"
                                    checked={props.showGridLines}
                                    onClick={() => props.changeShowGridLines(!props.showGridLines)}
                                />
                                {props.chartName === "engagement_over_time" ? (
                                    <CustomCheckBox label="Show Average" checked={showAverage} onClick={() => setShowAverage((val) => !val)} />
                                ) : null}
                                {/* <CustomCheckBox label="Show Label" checked={props.showLabel} onClick={() => props.changeShowLabel(!props.showLabel)} /> */}
                                <FBIntervalSelector
                                    aggs_val={props.aggs_val}
                                    appliedFilter={props.appliedFilter}
                                    handleIntervalChange={props.handleIntervalChange}
                                />
                            </>
                        )}
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )}
            </div>
            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chart}>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}

                    <EngagementByLikeComment
                        setIsNoDataState={setIsNoDataState}
                        showLegend={props.showLegend}
                        showGridLines={props.showGridLines}
                        showLabel={props.showLabel}
                        graphType={props.graph_type}
                        chartData={props.data}
                        chartDataLoading={props.chartDataLoading}
                        isIGPage={props.isIGPage}
                        widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                        pageStatus={props.pageStatus}
                        showAverage={showAverage}
                        widgetType={props.chartName}
                    />
                </div>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => increment()}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default EngagementOverTime;
